module.exports = __webpack_public_path__ + "static/home-2349fbd79d62709e319bbcbf60dbfdda.jpg";